import { WelcomepageDialogComponent } from 'src/app/welcomepage-dialog/welcomepage-dialog.component';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ApiService, UserService, ProfileService, AuthService, CookiesService, OidcService } from './services';
import { HttpTokenInterceptor, ResponseInterceptor } from './interceptors';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { HomeMaterialModule } from '../home/home-material/home-material.module';
import { MatProgressSpinnerModule } from '@angular/material';
import { AcknowldgementDialogComponent } from '../acknowldgement-dialog/acknowldgement-dialog.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    WelcomepageDialogComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,
    MatIconModule,
    MatSelectModule,
    TranslateModule,
    HomeMaterialModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    ApiService,
    UserService,
    ProfileService,
    AuthService,
    CookiesService,
    OidcService
  ],
  
  entryComponents:[WelcomepageDialogComponent,AcknowldgementDialogComponent]
})
export class CoreModule { }
